export const ROUTES = {
  /** Legacy, before practice-scoped routes — redirects to the practice picker. */
  patient:                '/patient',
  practices:              '/praktijken',
  practice:               '/praktijk/:orgSlug',
  practiceIntake:         '/praktijk/:orgSlug/intake',
  practiceConversation:   '/praktijk/:orgSlug/consulten/:id',
  login:                  '/login',
  suspended:              '/geblokkeerd',
  callback:               '/callback',
  profile:                '/profile',
  /** Legacy, before practice-scoped routes — redirects to the practice picker. */
  intake:                 '/intake',
  doctors:                '/doctors',
  conversationPay:        '/conversations/pay/:id',
  conversation:           '/conversations/:id',
  doctorDashboard:        '/doctor',
  doctorConsultations:    '/doctor/consultations',
  doctorVerification:     '/doctor/verification',
  doctorPayments:         '/doctor/payments',
  doctorStatistics:       '/doctor/statistics',
  doctorProfile:          '/doctor/profile',
  doctorSupportTickets:   '/doctor/support',
  platformInfo:           '/info',
  medicalDisclaimer:      '/legal/medical-disclaimer',
  userAgreement:          '/legal/user-agreement',
  privacyPolicy:          '/legal/privacy-policy',
  operator:               '/operator',
  operatorOperations:     '/operator/beheer',
  operatorAnalytics:      '/operator/analytics',
  operatorAudit:          '/operator/audit',
  operatorDoctors:        '/operator/doctors',
  operatorOrganizations:  '/operator/organizations',
  operatorPatients:       '/operator/patients',
  operatorHygiene:        '/operator/hygiene',
  operatorSupportTickets: '/operator/support-tickets',
  practiceAdmin:          '/praktijkbeheer',
  practiceAdminReport:    '/praktijkbeheer/overzicht',
  practiceAdminBranding:  '/praktijkbeheer/huisstijl',
  practiceAdminPayments:  '/praktijkbeheer/betalingen',
  /** MOLLIE_CONNECT_REDIRECT_URL points here; register it on the Mollie OAuth app. */
  practiceAdminMollieCallback: '/praktijkbeheer/betalingen/mollie',
  /** Legacy, before the practice admin section — redirects to practiceAdmin. */
  practiceSettings:       '/praktijk',
} as const;

/** The practice-scoped patient routes with the practice (and conversation) filled in. */
export function practicePath(slug: string): string {
  return ROUTES.practice.replace(':orgSlug', slug);
}
export function practiceIntakePath(slug: string): string {
  return ROUTES.practiceIntake.replace(':orgSlug', slug);
}
export function practiceConversationPath(slug: string, conversationId: number | string): string {
  return ROUTES.practiceConversation.replace(':orgSlug', slug).replace(':id', String(conversationId));
}
